export default __webpack_public_path__ + "static/media/flagke.94e1354d.svg";